import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Route, Switch, Redirect } from 'react-router-dom';
import Authorization from '../../authorization/authorization';
import Dashboard from '../../dashboard/dashboard.js';
import Navigation from './navigation';
import EmptyViewer from '../../churchSelector/emptyViewer';
import ChurchSelector from '../../churchSelector/churchSelector';
import { NAVIGATION_CONTENT_KEY, MAIN_CONTENT_KEY, HEADER_CONTENT_KEY } from '../../dashboard/constants';
import { ROLES, ROLE_SETS } from '../../authorization/roles';
import { MINIMUM_PUBLISHED_PHASE } from '../successReports/constants'
import StatisticsPage from '../statistics/statisticsPage';
import ChurchProfile from '../churchProfile/churchProfile';
import DailyScriptures from '../dailyScriptures/dailyScriptures';
import CreateScripturePage from '../dailyScriptures/createScripture';
import FaqAnswers from '../faqAnswers/faqAnswers';
import CreateFaqAnswers from '../faqAnswers/createFaqAnswer';
import Profile from '../profile/profile';
import SuccessReports from '../successReports/successReports';
import BarriersPage from '../barriers/barriers';
import ChurchMembers from '../churchMembers/churchMembers';
import ChurchesPage from "../churches/churches";
import EvangelistsPage from "../evangelists/evangelists";
import Settings from "../settings/settings";
import './dashboard.css';

class DashboardPage extends Component {
  pagePath(key) {
    return `${this.props.match.url}/${key}`;
  }

  get configs() {
    return [
      {
        itemKey: 'stats',
        path: this.pagePath('stats'),
        title: 'Stats',
        iconKey: 'icon-statistics',
        roles: ROLE_SETS.churchManagers,
        component: StatisticsPage
      },
      {
        itemKey: 'barriers',
        path: this.pagePath('barriers'),
        title: 'Barriers',
        iconKey: 'icon-barrier',
        roles: ROLE_SETS.churchTopManagers,
        component: BarriersPage
      },
      {
        itemKey: 'churchProfile',
        path: this.pagePath('churchProfile'),
        title: 'Church Profile',
        iconKey: 'icon-church',
        roles: ROLE_SETS.churchManagers,
        component: ChurchProfile
      },
      {
        itemKey: 'churchMembers',
        path: this.pagePath('churchMembers'),
        title: 'Church Members',
        iconKey: 'icon-people',
        roles: ROLE_SETS.churchManagers,
        component: ChurchMembers
      },
      {
        itemKey: 'churches',
        path: this.pagePath('churches'),
        title: 'Church list',
        iconKey: 'custom-scriptures',
        roles: ROLE_SETS.admins,
        component: ChurchesPage
      },
      {
        itemKey: 'evangelists',
        path: this.pagePath('evangelists'),
        title: 'Evangelists',
        iconKey: 'evangelists',
        roles: ROLE_SETS.admins,
        component: EvangelistsPage
      },
      {
        itemKey: 'scripturesList',
        path: this.pagePath('scripturesList'),
        title: 'Scriptures list',
        iconKey: 'custom-scriptures',
        roles: ROLE_SETS.admins,
        component: DailyScriptures
      },
      {
        itemKey: 'uploadScriptures',
        path: this.pagePath('uploadScriptures'),
        title: 'Upload scriptures',
        iconKey: 'custom-scriptures',
        roles: ROLE_SETS.admins,
        component: CreateScripturePage
      },
      {
        itemKey: 'faqAnswersList',
        path: this.pagePath('faqAnswersList'),
        title: 'Faq Answers list',
        roles: ROLE_SETS.admins,
        component: FaqAnswers
      },
      {
        itemKey: 'createFaqAnswers',
        path: this.pagePath('createFaqAnswers'),
        title: 'Add FAQ Answer',
        roles: ROLE_SETS.admins,
        component: CreateFaqAnswers
      },
      {
        itemKey: 'settings',
        path: this.pagePath('settings'),
        title: 'Settings',
        roles: ROLE_SETS.admins,
        component: Settings
      },
      {
        itemKey: 'profile',
        path: this.pagePath('profile'),
        roles: ROLE_SETS.all,
        component: Profile,
        excludeFromMenu: true
      },
      {
        itemKey: 'successReports',
        path: this.pagePath('successReports'),
        title: 'Event Reports',
        iconKey: 'icon-report',
        roles: this.successReportsRoles,
        component: SuccessReports
      }
    ];
  }

  get successReportsRoles() {
    const isAppropriateRole = ROLE_SETS.churchManagers.find((churchManagers) => {
      return churchManagers === this.props.user.type;
    });

    if (isAppropriateRole && this.props.selectedChurch.revival.phase === MINIMUM_PUBLISHED_PHASE) {
      return ROLE_SETS.churchManagers;
    } else {
      return ROLE_SETS.churchTopManagers;
    }
  }

  get headerContentComponent() {
    const { type: role } = this.props.user;
    switch(role) {
      case ROLES.admin:
        return EmptyViewer;
      default:
        return ChurchSelector;
    }
  }

  get content() {
    const { type: role } = this.props.user;
    const configs = this.configs.filter((config) => config.roles.includes(role));
    return [
      <this.headerContentComponent key={HEADER_CONTENT_KEY} user={this.props.user} churches={this.props.churches}
                                   selectedChurch={this.props.selectedChurch}
                                   disabled={ROLE_SETS.pastors.includes(this.props.user.type)}/>,
      <Navigation key={NAVIGATION_CONTENT_KEY} configs={configs} />,
      <Switch key={MAIN_CONTENT_KEY}>
        {this.routs(configs)}
        <Redirect to="/404" />
      </Switch>
    ]
  }

  routs(configs) {
    const rootRoute = <Route exact key={`route_to_${this.props.match.url}`} path={`${this.props.match.url}`}
                             render={() => <Redirect to={configs[0].path} />} />;
    const pageRoutes = configs.map((config) => {
      return <Route key={`route_to_${config.path}`} path={config.path}
                    component={Authorization(config.roles, this.props)(config.component)} />;
    });

    return [rootRoute].concat(pageRoutes);
  }

  render() {
    return (
      <Dashboard {...this.props}>
        { this.content }
      </Dashboard>
    );
  }
}

export default withRouter(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/dashboard.js